/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}date-range-picker`;
export class DatePickerRange {
    constructor(range) {
        if (range) {
            this.from = range.from;
            this.to = range.to;
        }
    }
    copy() {
        return new DatePickerRange(this);
    }
}
const observedAttributes = {
    FROM: 'from',
    TO: 'to',
    END_VALUE: 'end-value'
};
const selectors = {
    INPUT: 'input'
};
const events = {
    CHANGE: `${elementName}-change`,
    OPEN: `${elementName}-open`,
    CLOSE: `${elementName}-close`,
    INPUT: `${elementName}-input`
};
export const DATE_RANGE_PICKER_CONSTANTS = {
    elementName,
    selectors,
    events,
    observedAttributes
};
